import store from '../store'

const sessions = {
	users: ['userModel', 'user', 'set', '/sign-in'],
	admin: ['QoSAdminModel', 'admin', 'setAdmin', '/admin/sign-in'],
	sdoc: ['sdocUserModel', 'userSDOC', 'setUserSDOC', '/sdoc/sign-in'],
	'sdoc-admin': ['sdocAdminModel', 'adminSDOC', 'setAdminSDOC', '/admin/sdoc/sign-in'],
	'main-admin': ['mainAdminModel', 'admin', 'setAdmin', '/main-admin/sign-in'],
}

export function getAuthSession(appType = store.getState().appModel.app_type) {
	const definition = sessions[appType]
	return {
		appType,
		token: definition ? store.getState()[definition[0]][definition[1]]?.token : null,
	}
}

export function getTokenExpiry(token) {
	try {
		const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
		const { exp } = JSON.parse(window.atob(payload))
		return Number.isFinite(exp) ? exp * 1000 : null
	} catch {
		return null
	}
}

// Clear synchronously before awaiting persistence: simultaneous failures then
// see no matching session, and responses from an older login cannot log out a new one.
export async function expireAuthSession(session, message = 'หมดเวลาใช้งาน กรุณาเข้าสู่ระบบใหม่') {
	if (!session?.token || getAuthSession(session.appType).token !== session.token) return
	const [model, , setter, loginPath] = sessions[session.appType]
	const actions = store.getActions()[model]
	actions[setter](null)
	if (session.appType === 'sdoc-admin') actions.setAdminMeSDOC(null)
	if (session.appType === 'sdoc') actions.setUserMeSDOC(null)
	try {
		if (store.persist?.flush) await store.persist.flush()
	} catch {
		// Storage failure must not prevent returning to the login screen.
	} finally {
		// A failure from a background portal must not navigate the active portal.
		if (store.getState().appModel.app_type === session.appType &&
			!getAuthSession(session.appType).token) {
			window.alert(message)
			window.location.replace(loginPath)
		}
	}
}

export function handleAuthResponse(response) {
	const session = response.config?.authSession
	if (session?.appType === 'sdoc' && session.token === getAuthSession('sdoc').token) {
		const expireDate = store.getState().sdocUserModel.userLoginExpireDate
		if (expireDate == null || Date.now() >= expireDate) {
			void expireAuthSession(session)
		}
	}
	return response
}

export function handleAuthError(error) {
	if (error.response?.status === 401) {
		void expireAuthSession(error.config?.authSession)
	}
	return Promise.reject(error)
}
